'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'circle-half';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e110';
var svgPathData = ['M16 256c0 122.4 91.6 223.4 210 238.1c6.7 .8 14-4.7 14-14.2l0-448c0-9.4-7.3-15-14-14.1C107.6 32.6 16 133.6 16 256z', 'M226 17.9C107.6 32.6 16 133.6 16 256s91.6 223.4 210 238.1c6.7 .8 14-4.7 14-14.2l0-448c0-9.4-7.3-15-14-14.1zM224.1 2C241.6-.2 256 14.3 256 32l0 448c0 17.7-14.4 32.2-31.9 30C97.8 494.3 0 386.6 0 256S97.8 17.7 224.1 2z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleHalf = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;